<template>
  <div
    class="Fuell-Table--row"
    @click="showTransactionDetail"
    :style="tableGridTemplateStyle"
  >
    <div
      class="Fuell-Table--item clickable "
      :class="transactionStatusLabelClass"
    >
      <span
        class="ellipsis"
        v-tooltip="$t(transactionStatusLabel)"
      >
        {{$t(transactionStatusLabel)}}
      </span>

    </div>
    <div class="Fuell-Table--item">
      <img
        class="transaction-locked-icon"
        alt="transaction-locked-icon"
        v-tooltip="transactionLockedByTooltipLabel"
        v-if="transactionIsLocked"
        :src="require(`@/assets/img/icons/${transactionIsLockedIcon}.svg`)"
      />
    </div>
    <div
      class="Fuell-Table--item clickable transaction-date"
      :class="{ pending: transactionIsPending }"
    >
      {{ transactionDate | formatTheDate('short') }}
      <inline-svg
        :src="require('@/assets/img/icons/icon-watch.svg')"
        v-if="transactionIsPending"
        class="pending-icon"
      />
    </div>

    <div
      class="Fuell-Table--item clickable"
      v-tooltip="transactionMerchant"
    >
      <span class="ellipsis">{{ transactionMerchant }}</span>
    </div>

    <div
      class="Fuell-Table--item clickable dark amount"
      :class="{
        pending: transactionIsPending,
        declined: transactionIsDeclined,
        refund: transactionIsRefund
      }"
    >
      {{
        transactionAmmount
          | currency('€', 2, {
            symbolOnLeft: false,
            thousandsSeparator: '.',
            decimalSeparator: ','
          })
      }}
    </div>
  </div>
</template>

<script>
import InlineSvg from 'vue-inline-svg'
import _transactionsTableRowInfo from '../../../transactions/_mixins/_transactionsTableRowInfo'
import _transactionStatusHandlerMixin from '../../../transactions/_mixins/_transactionStatusHandlerMixin'

export default {
  name: 'CardDetailTransactionsTableRow',
  props: {
    transaction: {
      type: Object,
      required: true
    },
    columns: {
      type: Array,
      required: true
    }
  },
  mixins: [_transactionsTableRowInfo, _transactionStatusHandlerMixin],
  data () {
    return {
      isSubmitting: false
    }
  },
  computed: {
    tableGridTemplateStyle () {
      return {
        gridTemplateColumns: this.columns.map(c => c.template).join(' ')
      }
    }
  },
  components: {
    InlineSvg
  },
  methods: {
    showTransactionDetail () {
      this.$emit('showTransactionDetail', this.transaction.id)
    }
  }
}
</script>

<style scoped>
.pending {
  color: var(--gray);
  opacity: 0.72;
}
.refund {
  color: var(--semantic-positive-main);
}
.transaction-date .pending-icon {
  position: relative;
  left: 2px;
  top: -6px;
}
.amount {
  font-weight: 300;
}
.transaction-locked-icon {
  width: 16px;
  height: 16px;
  margin-left: auto;
  margin-right: 5px;
}
</style>
